import { ConfigProvider, Spin } from "antd";
import localforage from "localforage";
import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";

const CreateStoreContext = createContext(null);

const CreateStoreDispatchContext = createContext(null);

export const initialData = {
  steps: {
    currentIndex: 0,
  },
  stepItems: [
    {
      title: "Account Information",
      description: "Credentials for your account.",
      disabled: false,
      status: "process",
    },
    {
      title: "Store Information",
      description: "Provide details about your store.",
      disabled: true,
      status: "wait",
    },
    {
      title: "Contact Information",
      description: "Details that will receive messages from Bevz.",
      disabled: true,
      status: "wait",
    },
    {
      title: "Business Information",
      description: "Relevant details about your business.",
      disabled: true,
      status: "wait",
    },
    {
      title: "Store Hours",
      description: "Set your store’s operating hours.",
      disabled: true,
      status: "wait",
    },
    {
      title: "Subscription Plan",
      description: "Choose your preferred subscription",
      disabled: true,
      status: "wait",
    },
    {
      title: "Review Summary",
      description: "Check all the details are correct and accurate.",
      disabled: true,
      status: "wait",
    },
  ],
  operationHours: [
    {
      id: "1",
      days: [],
      closeTime: "",
      openTime: "",
      type: "DAILY_HOURS",
      error: {
        status: "",
        message: "",
        invalidTime: false,
        invalidDays: false,
      },
    },
  ],

  loginDetails: {
    token: null,
    storeDetails: {},
  },
};

export function CreateStoreProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [store, dispatch] = useReducer(storeReducer, initialData);

  useEffect(() => {
    (async () => {
      try {
        const initData = await localforage.getItem("storeV2");

        if (initData) {
          dispatch({ type: ACTIONTYPES.INIT, data: initData });
        }

        setLoading(false);
      } catch (err) {
        console.error("Failed to load store data:", err);
      }
    })();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Inter",
        },
      }}
    >
      <CreateStoreContext.Provider value={store}>
        <CreateStoreDispatchContext.Provider value={dispatch}>
          {loading ? <Spin size="large" fullscreen /> : children}
        </CreateStoreDispatchContext.Provider>
      </CreateStoreContext.Provider>
    </ConfigProvider>
  );
}

export function useStore() {
  return useContext(CreateStoreContext);
}

export function useStoreDispatch() {
  return useContext(CreateStoreDispatchContext);
}

export const ACTIONTYPES = {
  ACCOUNT: "account",
  ACCOUNTTYPE: "accountType",
  STORE: "store",
  CONTACT: "contact",
  BUSINESS: "business",
  OPERATIONHOURS: "operationHours",
  PLAN: "plan",
  STEPS: "steps",
  STRIPECLIENT: "stripeClient",
  INIT: "init",
  CLEARSTATES: "clearStates",
  LOGINDETAILS: "loginDetails",
  INTEGRATOR: "integrator",
  ADMIN_SELECTEDSTORE: "selectedStore",
  ADMIN_PARENTSTORE: "parentStore",
  CLEAR_FORM_STATES: "clearFromStates",
};

function storeReducer(state, action) {
  let _state = { ...state };
  switch (action.type) {
    case ACTIONTYPES.INTEGRATOR: {
      _state = { ...state, integrator: action.data };
      break;
    }
    case ACTIONTYPES.CLEAR_FORM_STATES: {
      const { parentStore, selectedStore, loginDetails } = state;
      _state = {
        steps: {
          currentIndex: 0,
          lastStepIndex: 0,
        },
        stepItems: [...initialData.stepItems],
        operationHours: initialData.operationHours,
        parentStore,
        selectedStore,
        loginDetails,
      };
      break;
    }
    case ACTIONTYPES.ADMIN_PARENTSTORE: {
      _state = { ...state, parentStore: action.data };
      break;
    }
    case ACTIONTYPES.ADMIN_SELECTEDSTORE: {
      _state = { ...state, selectedStore: action.data };
      break;
    }
    case ACTIONTYPES.LOGINDETAILS: {
      _state = { ...state, loginDetails: action.data };
      break;
    }
    case ACTIONTYPES.ACCOUNT: {
      _state = { ...state, account: action.data };
      break;
    }
    case ACTIONTYPES.ACCOUNTTYPE: {
      _state = { ...state, accountType: action.data };
      break;
    }
    case ACTIONTYPES.STORE: {
      _state = { ...state, store: action.data };
      break;
    }
    case ACTIONTYPES.CONTACT: {
      _state = { ...state, contact: action.data };
      break;
    }
    case ACTIONTYPES.BUSINESS: {
      _state = { ...state, business: action.data };
      break;
    }
    case ACTIONTYPES.OPERATIONHOURS: {
      _state = { ...state, operationHours: action.data };
      break;
    }
    case ACTIONTYPES.PLAN: {
      _state = { ...state, plan: action.data };
      break;
    }
    case ACTIONTYPES.STEPS: {
      _state = {
        ...state,
        steps: {
          currentIndex: action.data.currentIndex,
          lastStepIndex: action.data.lastStepIndex,
        },
        stepItems: [...action.data.stepItems],
      };
      break;
    }
    case ACTIONTYPES.STRIPECLIENT: {
      _state = { ...state, stripeClient: action.data };
      break;
    }
    case ACTIONTYPES.INIT: {
      return action.data;
    }
    case ACTIONTYPES.CLEARSTATES: {
      _state = initialData;
      break;
    }
    default: {
      return state;
    }
  }

  try {
    localforage.setItem("storeV2", _state);
  } catch (error) {
    console.error("Failed saving states locally.");
  }
  return _state;
}
